import _ from 'lodash';
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {TabContext} from './StickyTab';
import {tabActiveState, tabUiSetup} from './tabSetup';

const LinkWrapper = (props) => <Link {..._.omit(props, 'active')} />;

const TabLinkWrapper = styled(LinkWrapper)`
    ${tabUiSetup()};
    ${({active}) => tabActiveState(active)};
`;
const TabBtnWrapper = styled.button`
    ${tabUiSetup()};
    ${({active}) => tabActiveState(active)};
`;

// Allows the TabOption to "remember" the tab that has to be shown based on user context
const SmartTabBtnWrapper = ({id, children}) => {
    const {activeTab, setActiveTab} = useContext(TabContext);
    return (
        <TabBtnWrapper onClick={() => setActiveTab(id)} active={activeTab == id}>
            {children}
        </TabBtnWrapper>
    );
};

/**
 * @param {object} param0
 * @param {boolean} [param0.active]
 * @param {import('react').ReactNode} param0.children
 * @param {boolean} [param0.link]
 * @param {string} [param0.id]
 * @returns {import('react').ReactElement}
 */
const TabOption = ({link, id, children, ...rest}) => (
    <>
        {link && <TabLinkWrapper {...rest}>{children}</TabLinkWrapper>}
        {!link && !id && <TabBtnWrapper {...rest}>{children}</TabBtnWrapper>}
        {id && <SmartTabBtnWrapper id={id}>{children}</SmartTabBtnWrapper>}
    </>
);

export {TabBtnWrapper, TabOption};
